import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import '@finx/web-repository/src/components/_'

const requireComponentLib = require.context('@finx/web-repository/src/components', true, /\.vue$/)
const requireComponents = require.context('@/components', true, /\.vue$/)
const requireComponentViews = require.context('@/views', true, /(components).*\.vue$/)
const requireComponentLayouts = require.context('@/layouts', true, /\.*\.vue$/)
const requireComponentTemplate = require.context('@/components/SolicitacaoCirurgia/Template', true, /\.*\.vue$/)
const requireComponentSolicitacaoForm = require.context('@/components/SolicitacaoCirurgia/form', true, /\.*\.vue$/)
const requireComponentSolicitacaoModais = require.context('@/components/SolicitacaoCirurgia/modais', true, /\.*\.vue$/)
const requireComponentShared = require.context('@/components/shared', true, /\.*\.vue$/)
const requireComponentCadastroMedico = require.context('@/components/CadastroMedico/Forms', true, /\.*\.vue$/)
const requireChat = require.context('@/components/Chat/', true, /\.*\.vue$/)
const requireComponentRemuneracaoMedica = require.context('@/components/RemuneracaoMedica/', true, /\.*\.vue$/)
const requireComponentRemuneracaoMedicaContratosModais = require.context('@/components/RemuneracaoMedica/contratos/modais', true, /\.*\.vue$/)
const requireComponentRemuneracaoMedicaFinanceiroModais = require.context('@/components/RemuneracaoMedica/financeiro/modais', true, /\.*\.vue$/)
const requireComponentRemuneracaoMedicaNavBar = require.context('@/components/RemuneracaoMedica/NavBar', true, /\.*\.vue$/)
const requireComponentBackoffice = require.context('@/components/Backoffice', true, /\.*\.vue$/)
const requireComponentBackofficeNavBar = require.context('@/components/Backoffice/NavBar', true, /\.*\.vue$/)
const requireBackofficeSessao = require.context('@/components/Backoffice/sessao', true, /\.*\.vue$/)
const requireBackofficeModais = require.context('@/components/Backoffice/modais', true, /\.*\.vue$/)
const requireBackofficeComponents = require.context('@/components/Backoffice/components', true, /\.*\.vue$/)
const requireHomeCards = require.context('@/components/Home', true, /\.*\.vue$/)
const requireHomeComponents = require.context('@/components/Home/components', true, /\.*\.vue$/)
const requireNetPromoterScore = require.context('@/components/NetPromoterScore', true, /\.*\.vue$/)
const termosAceites = require.context('@/components/TermosAceites', true, /\.*\.vue$/)
const custom = require.context('@/components/custom', true, /\.*\.vue$/)

function createComponents(requireComponent, isRecursive = false) {
  requireComponent.keys()
    .forEach((fileName) => {
      let component = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')

      if (isRecursive) {
        component = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '').replace('components/', '').replace(/^[^/]*\//, '')
      }

      const componentConfig = requireComponent(fileName)
      const componentName = upperFirst(camelCase(component))

      Vue.component(componentName, componentConfig.default || componentConfig)
    })
}

createComponents(requireComponentLib)
createComponents(requireComponents, true)
createComponents(requireComponentViews, true)
createComponents(requireComponentLayouts)
createComponents(requireComponentTemplate, true)
createComponents(requireComponentSolicitacaoForm, true)
createComponents(requireComponentSolicitacaoModais, true)
createComponents(requireComponentShared, true)
createComponents(requireChat)
createComponents(requireComponentCadastroMedico)
createComponents(requireComponentRemuneracaoMedica)
createComponents(requireComponentRemuneracaoMedicaContratosModais)
createComponents(requireComponentRemuneracaoMedicaFinanceiroModais)
createComponents(requireComponentRemuneracaoMedicaNavBar)
createComponents(requireComponentBackoffice)
createComponents(requireComponentBackofficeNavBar)
createComponents(requireBackofficeSessao)
createComponents(requireBackofficeModais, true)
createComponents(requireBackofficeComponents)
createComponents(requireHomeCards)
createComponents(requireHomeComponents)
createComponents(requireNetPromoterScore)
createComponents(termosAceites)
createComponents(custom)
